module.exports = __webpack_public_path__ + "static/interaction-studio-logo-dev-197x35-retina-ready@2x-debd1c0378c4c87a3894a01c46fc22a4.png";